import Head from 'next/head'

import ColoredLink from '../components/ColoredLink'
import IndentedList from '../components/IndentedList'
import Layout from '../components/Layout'

export default function Ceremony(): JSX.Element {
  return (
    <Layout>
      <Head>
        <title>Robert Karasov - Minneapolis Mohel | The Ceremony</title>
      </Head>
      <h1 className="mb-6 font-serif text-4xl text-ink sm:text-3xl">
        The Ceremony
      </h1>
      <section>
        <div className="space-y-4 leading-relaxed text-ink">
          <IndentedList>
            <li>
              <ColoredLink href="/BritMilahCeremony.pdf" target="_blank">
                Text of the Ceremony
              </ColoredLink>
            </li>
          </IndentedList>
          <p>
            The ceremony begins with the Kvatter and Kvatterin (godparents)
            carrying the baby into the room and the Kvatter holding the baby on
            the chair of Elijah. After a few readings from family and friends,
            the Mohel recites a blessing and performs the bris as the baby is
            comforted by the Sandek. The parents say a blessing after the
            circumcision and the community responds welcoming the baby into the
            covenant. After a prayer for healing, the baby is then given a
            Hebrew name over a glass of wine. The ceremony concludes with
            blessing the baby and reciting the Shehechianu followed by a festive
            meal.
          </p>
          <p>
            You are encouraged to invite your Rabbi or Cantor to the Bris and we
            will arrange how to co-officiate at the ceremony.
          </p>
        </div>
      </section>
    </Layout>
  )
}
